import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';

@Component({
  selector: 'app-confirm',
  template: `
    <div *ngIf="data.icon" class="icon-container">
      <mat-icon>{{ data.icon }}</mat-icon>
    </div>
    <h1 matDialogTitle class="mb-05">{{ data.title }}</h1>
    <div mat-dialog-content class="mb-1">{{ data.message }}</div>
    <div mat-dialog-content *ngIf="data.options">
      <p>Por favor selecione {{data.messageOptions}}:</p>
      <mat-form-field>
      <mat-select placeholder="{{data.messageOptions}}?" [(ngModel)]="selectedChoice" >
      <mat-option *ngFor="let opt of data.options" [value]="opt" >{{opt}}</mat-option>
      </mat-select>
    </mat-form-field>
    </div>
    <div mat-dialog-content *ngIf="data.containsText">
      <p>{{data.messageOptions}}
      </p>
      <mat-form-field appearance="outline" style="width: 100%;">
        <input matInput placeholder="{{data.title}}" [(ngModel)]="selectedText" type="text">
      </mat-form-field>
    </div>
    <div mat-dialog-actions>
    <button
    type="button"
    mat-raised-button
    color="primary"
    (click)="confirmSelection()">OK</button>
    &nbsp;
    <span fxFlex></span>
    <button  *ngIf="!data.disableCancel"
    type="button"
    color="accent"
    mat-raised-button
    (click)="dialogRef.close(false)">Cancelar</button>
    </div>`,
})



export class AppComfirmComponent {
  selectedChoice: any = true;

  selectedText: any = '';


  constructor(
    public dialogRef: MatDialogRef<AppComfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.selectedChoice = data.defaultOption;
    this.selectedText = this.data.selectedText;

  }
  confirmSelection() {
    this.dialogRef.close(this.data?.containsText !== undefined ? this.selectedText : this.selectedChoice);
  }

}
